import React from 'react'

import TextField from '@mui/material/TextField'


export default function LoginInput({
  name, 
  label, 
  handleFunc, 
  submitFunc,
  value, 
  error,
}){
  const submitAnswer = event => {
    if (event.key === 'Enter') {
      submitFunc()
    }
  }
return(
      <TextField
        error={error.length>0 ? true : false}
        helperText={error}
        variant="outlined"
        color='secondary'
        onKeyDown={submitAnswer}
        required
        sx={{backgroundColor: 'white'}}
        fullWidth
        name={name}
        label={label}
        type={name}
        id={name} 
        autoComplete={name === "password" ? "current-password" :"email"}
        onChange={handleFunc}
        value={value}
      />
)}